<div class="row mt-3">
  <p-table
    stripedRows
    [rowHover]="true"
    [rows]="25"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    [size]="'small'"
    #nonAddLineTable
    styleClass="p-datatable-customers ordersListing search-more"
    [rowHover]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="true"
    [filterDelay]="0"
    selectionMode="multiple"
    [value]="nonAddedLines"
    (onRowSelect)="handleRowSelect($event)"
    (onRowUnselect)="handleRowUnselect($event)"
    [(selection)]="selectedLines"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th></th>
        <th class="notes">Line #</th>
        <th class="vendor-name">PO#</th>
        <th class="status">Vendor SKU</th>
        <th class="notes">Nickname</th>
        <th class="status header">Description</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-line let-ri="rowIndex">
      <ng-container>
        <tr>
          <td>
            <p-tableCheckbox [value]="line.lineRecIdD365"></p-tableCheckbox>
          </td>
          <td>{{ line.lineNumberD365 }}</td>
          <td>{{ line.proposalIdD365 }}</td>
          <td>{{ line.externalItemNumberD365 }}</td>
          <td>{{ line.nickName }}</td>
          <td>{{ line.lineDescriptionD365 }}</td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>
</div>
<div class="d-flex pt-2 justify-content-end gap-3">
  <!-- <button
    type="button"
    (click)="addLinesToProject()"
    class="btn btn-primary me-3"
    [disabled]="!addButtonEnabled">
    Add
  </button>
  <button
    type="button"
    (click)="closeModalDialog()"
    class="btn btn-secondary me-3">
    close
  </button> -->

  <p-button
    label="Add"
    (click)="addLinesToProject()"
    [disabled]="!addButtonEnabled" />

  <p-button
    label="close"
    variant="outlined"
    severity="secondary"
    (click)="closeModalDialog()" />
</div>
